import apiClient from '../../../core/Api';
import { ContentQueryParams } from '../../../data/types/content.interface';
import { TagRequestParams, TagType } from '../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class AssetContentTypeService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/assets/content-type`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/assets/content-type`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteAsset = async (name: string): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/assets/content-type/${name}`);
    return response.status === 204;
  };

  static getContents = async (params: ContentQueryParams): Promise<any> =>
    apiClient.get(`${API_BASE_URL}/assets/content-type/contents`, { params }).then((response) => {
      const { data } = response;
      return data;
    });
}

export default AssetContentTypeService;
